<template>
  <div  id="main-content">
		<div  id="sub-header" class="layout-full elementor-page-title">
			<div class="meta-header" ></div>
		</div>
		<div id="main" role="main" class="vamtam-main layout-full" >
			<div class="page-wrapper">
				<article id="post-812" class="full post-812 page type-page status-publish hentry">
					<div class="page-content clearfix the-content-parent">
						<div data-elementor-type="wp-page" data-elementor-id="812" class="elementor elementor-812" data-elementor-post-type="page">
							<section class="elementor-section elementor-top-section elementor-element elementor-element-50582fc elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="50582fc" data-element_type="section" data-e-type="section">
								<div  class="elementor-container elementor-column-gap-no">
									<div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-051d7f9" data-id="051d7f9" data-element_type="column" data-e-type="column">
										<div class="elementor-widget-wrap elementor-element-populated">
											<div class="elementor-element elementor-element-0c9142b elementor-position-inline-end elementor-widget__width-auto elementor-mobile-position-inline-end elementor-widget-mobile__width-auto elementor-view-default elementor-widget elementor-widget-icon-box animated slideInUp" data-id="0c9142b" data-element_type="widget" data-e-type="widget" data-settings="{&quot;_animation&quot;:&quot;slideInUp&quot;,&quot;_animation_tablet&quot;:&quot;none&quot;}" data-widget_type="icon-box.default">
												<div class="elementor-widget-container">
													<div class="elementor-icon-box-wrapper">
														<div class="elementor-icon-box-icon">
															<span class="elementor-icon">
																<i aria-hidden="true" class="vamtamtheme- vamtam-theme-line-titles"></i>
															</span>
														</div>
														<div class="elementor-icon-box-content">
															<span class="elementor-icon-box-title">
																<span>{{ aboutContentStore.contents.about.title }}</span>
															</span>
														</div>
													</div>
												</div>
											</div>
											<div class="elementor-element elementor-element-fb4f29e elementor-widget elementor-widget-heading" data-id="fb4f29e" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
												<div class="elementor-widget-container">
													<h1 class="elementor-heading-title elementor-size-default">{{ aboutContentStore.contents.about.contentPage }}</h1>
												</div>
											</div>
										</div>
									</div>
									<div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-f75dbc0" data-id="f75dbc0" data-element_type="column" data-e-type="column">
										<div class="elementor-widget-wrap elementor-element-populated">
											<div class="vamtam-has-theme-widget-styles elementor-element elementor-element-67b1ecd elementor-widget elementor-widget-text-editor" data-id="67b1ecd" data-element_type="widget" data-e-type="widget" data-widget_type="text-editor.default">
												<div class="elementor-widget-container">
													<p v-html="aboutContentStore.contents.about.descriptions"></p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</section>
							<section class="elementor-section elementor-top-section elementor-element elementor-element-ac4e796 elementor-section-full_width elementor-section-height-min-height elementor-section-stretched elementor-section-height-default elementor-section-items-middle" data-id="ac4e796" data-element_type="section" data-e-type="section" data-settings="{'background_background':'classic','stretch_section':'section-stretched'}" :style="{backgroundImage: `url(${aboutContentStore.contents.about.image})`}">
								<div class="elementor-container elementor-column-gap-default">
									<div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-3c1db8f" data-id="3c1db8f" data-element_type="column" data-e-type="column">
										<div class="elementor-widget-wrap"></div>
									</div>
								</div>
							</section>
							<section class="elementor-section elementor-top-section elementor-element elementor-element-ca7dc3d elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="ca7dc3d" data-element_type="section" data-e-type="section" data-settings="{'background_background':'classic'}">
								<div  class="elementor-container elementor-column-gap-no">
									<div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-7a99355" data-id="7a99355" data-element_type="column" data-e-type="column">
										<div class="elementor-widget-wrap elementor-element-populated">
											<div class="elementor-element elementor-element-fc73c69 elementor-position-inline-end elementor-widget__width-auto elementor-mobile-position-inline-end elementor-widget-mobile__width-auto elementor-view-default elementor-widget elementor-widget-icon-box animated slideInUp" data-id="fc73c69" data-element_type="widget" data-e-type="widget" data-settings="{&quot;_animation&quot;:&quot;slideInUp&quot;,&quot;_animation_tablet&quot;:&quot;none&quot;}" data-widget_type="icon-box.default">
												<div class="elementor-widget-container">
													<div class="elementor-icon-box-wrapper">
														<div class="elementor-icon-box-icon">
															<span class="elementor-icon">
																<i aria-hidden="true" class="vamtamtheme- vamtam-theme-line-titles"></i>
															</span>
														</div>
														<div class="elementor-icon-box-content">
															<span class="elementor-icon-box-title">
																<span>{{ aboutContentStore.contents.focus.section }}</span>
															</span>
														</div>
													</div>
												</div>
											</div>
											<div class="elementor-element elementor-element-8edbc01 elementor-widget elementor-widget-heading" data-id="8edbc01" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
												<div class="elementor-widget-container">
													<h2 class="elementor-heading-title elementor-size-default">
														{{ aboutContentStore.contents.focus.title }} 
													</h2>
												</div>
											</div>
										</div>
									</div>
								</div>
							</section>
							<section class="elementor-section elementor-top-section elementor-element elementor-element-c771a42 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="c771a42" data-element_type="section" data-e-type="section">
								<div  class="elementor-container elementor-column-gap-no">
									<div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-522ebbd" data-id="522ebbd" data-element_type="column" data-e-type="column">
										<div class="elementor-widget-wrap elementor-element-populated">
											<div class="elementor-element elementor-element-363e258 elementor-position-inline-end elementor-widget__width-auto elementor-mobile-position-inline-end elementor-widget-mobile__width-auto elementor-view-default elementor-widget elementor-widget-icon-box animated slideInUp" data-id="363e258" data-element_type="widget" data-e-type="widget" data-settings="{&quot;_animation&quot;:&quot;slideInUp&quot;,&quot;_animation_tablet&quot;:&quot;none&quot;}" data-widget_type="icon-box.default">
												<div class="elementor-widget-container">
													<div class="elementor-icon-box-wrapper">
														<div class="elementor-icon-box-icon">
															<span class="elementor-icon">
																<i aria-hidden="true" class="vamtamtheme- vamtam-theme-line-titles"></i>
															</span>
														</div>
														<div class="elementor-icon-box-content">
															<span class="elementor-icon-box-title">
																<span>{{ aboutContentStore.contents.who.section }}</span>
															</span>
														</div>
													</div>
												</div>
											</div>
											<div class="elementor-element elementor-element-7eb3c52 elementor-widget elementor-widget-heading" data-id="7eb3c52" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
												<div class="elementor-widget-container">
													<h3 class="elementor-heading-title elementor-size-default">{{ aboutContentStore.contents.who.title }}</h3>
												</div>
											</div>
											<div class="elementor-element elementor-element-0edcb40 elementor-widget elementor-widget-image" data-id="0edcb40" data-element_type="widget" data-e-type="widget" data-widget_type="image.default">
												<div class="elementor-widget-container">
													<img fetchpriority="high" decoding="async" width="837" height="1024" :src="aboutContentStore.contents.who.image" class="attachment-large size-large wp-image-9807" alt="" :data-lazy-srcset="`${aboutContentStore.contents.who.image} 837w, ${aboutContentStore.contents.who.image} 245w, ${aboutContentStore.contents.who.image} 768w, ${aboutContentStore.contents.who.image} 1066w`" data-lazy-sizes="(max-width: 837px) 100vw, 837px" :data-lazy-src="aboutContentStore.contents.who.image" />
													<noscript><img fetchpriority="high" decoding="async" width="837" height="1024" :src="aboutContentStore.contents.who.image" class="attachment-large size-large wp-image-9807" alt="" :srcset="`${aboutContentStore.contents.who.image} 837w, ${aboutContentStore.contents.who.image} 245w, ${aboutContentStore.contents.who.image} 768w, ${aboutContentStore.contents.who.image} 1066w`" sizes="(max-width: 837px) 100vw, 837px" /></noscript>
												</div>
											</div>
										</div>
									</div>
									<div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-bae1a4b" data-id="bae1a4b" data-element_type="column" data-e-type="column">
										<div class="elementor-widget-wrap elementor-element-populated">
											<div class="vamtam-has-theme-widget-styles elementor-element elementor-element-bca4b47 elementor-widget elementor-widget-text-editor" data-id="bca4b47" data-element_type="widget" data-e-type="widget" data-widget_type="text-editor.default">
												<div class="elementor-widget-container" v-html="aboutContentStore.contents.ourHistory.contents"></div>
											</div>
											<div class="vamtam-has-theme-widget-styles elementor-element elementor-element-5d34636 vamtam-has-underline-anim elementor-widget elementor-widget-button" data-id="5d34636" data-element_type="widget" data-e-type="widget" data-widget_type="button.default">
												<div class="elementor-widget-container">
													<div class="elementor-button-wrapper">
														<a class="elementor-button elementor-button-link elementor-size-sm" href="#">
															<span class="elementor-button-content-wrapper">
																<span class="elementor-button-text">Our History</span>
															</span>
														</a>
													</div>
												</div>
											</div>
											<div class="elementor-element elementor-element-61e5c4c elementor-widget elementor-widget-image" data-id="61e5c4c" data-element_type="widget" data-e-type="widget" data-widget_type="image.default">
												<div class="elementor-widget-container">
													<img decoding="async" width="793" height="1024" :src="aboutContentStore.contents.ourHistory.image" class="attachment-large size-large wp-image-9808" alt="" :data-lazy-srcset="`${aboutContentStore.contents.ourHistory.image} 793w, ${aboutContentStore.contents.ourHistory.image} 232w, ${aboutContentStore.contents.ourHistory.image} 768w, ${aboutContentStore.contents.ourHistory.image} 1012w`" data-lazy-sizes="(max-width: 793px) 100vw, 793px" :data-lazy-src="aboutContentStore.contents.ourHistory.image" />
													<noscript><img decoding="async" width="793" height="1024" :src="aboutContentStore.contents.ourHistory.image" class="attachment-large size-large wp-image-9808" alt="" :srcset="`${aboutContentStore.contents.ourHistory.image} 793w, ${aboutContentStore.contents.ourHistory.image} 232w, ${aboutContentStore.contents.ourHistory.image} 768w, ${aboutContentStore.contents.ourHistory.image} 1012w`" sizes="(max-width: 793px) 100vw, 793px" /></noscript>
												</div>
											</div>
										</div>
									</div>
								</div>
							</section>
							<section class="elementor-section elementor-top-section elementor-element elementor-element-0d0b99f elementor-section-content-bottom elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="0d0b99f" data-element_type="section" data-e-type="section">
								<div  class="elementor-container elementor-column-gap-no">
									<div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-2438c86" data-id="2438c86" data-element_type="column" data-e-type="column">
										<div class="elementor-widget-wrap elementor-element-populated">
											<div class="elementor-element elementor-element-21ddcc1 elementor-position-inline-end elementor-widget__width-auto elementor-mobile-position-inline-end elementor-widget-mobile__width-auto elementor-view-default elementor-widget elementor-widget-icon-box animated slideInUp" data-id="21ddcc1" data-element_type="widget" data-e-type="widget" data-settings="{&quot;_animation&quot;:&quot;slideInUp&quot;,&quot;_animation_tablet&quot;:&quot;none&quot;}" data-widget_type="icon-box.default">
												<div class="elementor-widget-container">
													<div class="elementor-icon-box-wrapper">
														<div class="elementor-icon-box-icon">
															<span class="elementor-icon">
																<i aria-hidden="true" class="vamtamtheme- vamtam-theme-line-titles"></i>
															</span>
														</div>
														<div class="elementor-icon-box-content">
															<span class="elementor-icon-box-title">
																<span>{{aboutContentStore.contents.ourCommitment.section}}</span>
															</span>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</section>
							<section class="elementor-section elementor-top-section elementor-element elementor-element-b48930c elementor-section-content-bottom elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="b48930c" data-element_type="section" data-e-type="section">
								<div  class="elementor-container elementor-column-gap-no">
									<div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-7b028dc" data-id="7b028dc" data-element_type="column" data-e-type="column">
										<div class="elementor-widget-wrap elementor-element-populated">
											<div class="elementor-element elementor-element-f0251a7 elementor-widget elementor-widget-heading" data-id="f0251a7" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
												<div class="elementor-widget-container">
													<h3 class="elementor-heading-title elementor-size-default">{{aboutContentStore.contents.ourCommitment.title}}</h3>
												</div>
											</div>
										</div>
									</div>
									<div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-c164149" data-id="c164149" data-element_type="column" data-e-type="column">
										<div class="elementor-widget-wrap elementor-element-populated">
											<div class="vamtam-has-theme-widget-styles elementor-element elementor-element-3348cc0 elementor-widget elementor-widget-text-editor" data-id="3348cc0" data-element_type="widget" data-e-type="widget" data-widget_type="text-editor.default">
												<div class="elementor-widget-container" v-html="aboutContentStore.contents.ourCommitment.contents"></div>
											</div>
										</div>
									</div>
								</div>
							</section>
							<section class="elementor-section elementor-top-section elementor-element elementor-element-235873b elementor-section-height-min-height elementor-section-items-stretch elementor-section-boxed elementor-section-height-default" data-id="235873b" data-element_type="section" data-e-type="section">
								<div class="elementor-container elementor-column-gap-no">
									<div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-4dc92d4" data-id="4dc92d4" data-element_type="column" data-e-type="column" data-settings="{'background_background':'classic'}">
										<div class="elementor-widget-wrap" :style="{backgroundImage: `url(${aboutContentStore.contents.ourCommitment.image})`}"></div>
									</div>
								</div>
							</section>
							<section class="elementor-section elementor-top-section elementor-element elementor-element-8c31885 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="8c31885" data-element_type="section" data-e-type="section" data-settings="{'background_background':'classic'}">
								<div class="elementor-container elementor-column-gap-no">
									<div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-3b6a006" data-id="3b6a006" data-element_type="column" data-e-type="column">
										<div class="elementor-widget-wrap elementor-element-populated">
											<div class="elementor-element elementor-element-ae33003 elementor-position-inline-end elementor-widget__width-auto elementor-mobile-position-inline-end elementor-view-default elementor-widget elementor-widget-icon-box animated slideInUp" data-id="ae33003" data-element_type="widget" data-e-type="widget" data-settings="{&quot;_animation&quot;:&quot;slideInUp&quot;,&quot;_animation_tablet&quot;:&quot;none&quot;}" data-widget_type="icon-box.default">
												<div class="elementor-widget-container">
													<div class="elementor-icon-box-wrapper">
														<div class="elementor-icon-box-icon">
															<span class="elementor-icon">
																<i aria-hidden="true" class="vamtamtheme- vamtam-theme-line-titles"></i>
															</span>
														</div>
														<div class="elementor-icon-box-content">
															<span class="elementor-icon-box-title">
																<span>{{ aboutContentStore.contents.ourMission.section }}</span>
															</span>
														</div>
													</div>
												</div>
											</div>
											<div class="elementor-element elementor-element-69cd4ff elementor-widget elementor-widget-heading" data-id="69cd4ff" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
												<div class="elementor-widget-container">
													<h2 class="elementor-heading-title elementor-size-default">{{ aboutContentStore.contents.ourMission.title }}</h2>
												</div>
											</div>
										</div>
									</div>
								</div>
							</section>
							<section class="elementor-section elementor-top-section elementor-element elementor-element-04cbcb4 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="04cbcb4" data-element_type="section" data-e-type="section" data-settings="{'background_background':'classic'}">
								<div class="elementor-container elementor-column-gap-no">
									<div class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-ad3ba96 vamtam-cta-btn " data-id="ad3ba96" data-element_type="column" data-e-type="column">
										<div class="elementor-widget-wrap elementor-element-populated">
											<div class="elementor-element elementor-element-9ec9126 elementor-view-default elementor-position-block-start elementor-mobile-position-block-start elementor-widget elementor-widget-icon-box" data-id="9ec9126" data-element_type="widget" data-e-type="widget" data-widget_type="icon-box.default">
												<div class="elementor-widget-container">
													<div class="elementor-icon-box-wrapper">
														<div class="elementor-icon-box-icon">
															<a href="/safety" class="elementor-icon" tabindex="-1" aria-label="Safety">
																<i aria-hidden="true" class="vamtamtheme- vamtam-theme-miner"></i>
															</a>
														</div>
														<div class="elementor-icon-box-content">
															<h3 class="elementor-icon-box-title">
																<a href="/safety" >
																	{{aboutContentStore.contents.safety.section}}
																</a>
															</h3>
															<p class="elementor-icon-box-description" v-html="aboutContentStore.contents.safety.descriptions">
															</p>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-2eaa4e0" data-id="2eaa4e0" data-element_type="column" data-e-type="column">
										<div class="elementor-widget-wrap elementor-element-populated">
											<div class="elementor-element elementor-element-fda758c elementor-view-default elementor-position-block-start elementor-mobile-position-block-start elementor-widget elementor-widget-icon-box" data-id="fda758c" data-element_type="widget" data-e-type="widget" data-widget_type="icon-box.default">
												<div class="elementor-widget-container">
													<div class="elementor-icon-box-wrapper">
														<div class="elementor-icon-box-icon">
															<a href="/sustainability" class="elementor-icon" tabindex="-1" aria-label="Our Purpose">
																<i aria-hidden="true" class="vamtamtheme- vamtam-theme-plant-ground"></i>
															</a>
														</div>
														<div class="elementor-icon-box-content">
															<h3 class="elementor-icon-box-title">
																<a href="/sustainability" >
																	{{aboutContentStore.contents.ourPurpose.section}}
																</a>
															</h3>
															<p class="elementor-icon-box-description" v-html="aboutContentStore.contents.ourPurpose.descriptions"></p>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-22fd9d0" data-id="22fd9d0" data-element_type="column" data-e-type="column">
										<div class="elementor-widget-wrap elementor-element-populated">
											<div class="elementor-element elementor-element-99d429c elementor-view-default elementor-position-block-start elementor-mobile-position-block-start elementor-widget elementor-widget-icon-box" data-id="99d429c" data-element_type="widget" data-e-type="widget" data-widget_type="icon-box.default">
												<div class="elementor-widget-container">
													<div class="elementor-icon-box-wrapper">
														<div class="elementor-icon-box-icon">
															<a href="/projects" class="elementor-icon" tabindex="-1" aria-label="Our Position">
																<i aria-hidden="true" class="vamtamtheme- vamtam-theme-Buildings"></i>
															</a>
														</div>
														<div class="elementor-icon-box-content">
															<h3 class="elementor-icon-box-title">
																<a href="/projects" >
																	{{aboutContentStore.contents.ourPosition.section}}
																</a>
															</h3>
															<p class="elementor-icon-box-description" v-html="aboutContentStore.contents.ourPosition.descriptions"></p>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</section>
							<section class="elementor-section elementor-top-section elementor-element elementor-element-5b40de8 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="5b40de8" data-element_type="section" data-e-type="section">
                <div class="elementor-container elementor-column-gap-no">
                  <div class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-ee6b253" data-id="ee6b253" data-element_type="column" data-e-type="column">
                    <div class="elementor-widget-wrap elementor-element-populated">
                      <div class="elementor-element elementor-element-424f47e elementor-widget elementor-widget-heading animated fadeIn" data-id="424f47e" data-element_type="widget" data-e-type="widget" data-settings="{&quot;_animation&quot;:&quot;fadeIn&quot;,&quot;_animation_tablet&quot;:&quot;none&quot;,&quot;_animation_delay&quot;:200}" data-widget_type="heading.default">
                        <div class="elementor-widget-container">
                          <h2 class="elementor-heading-title elementor-size-default">{{ aboutContentStore.contents.leadership.title }}</h2>
                        </div>
                      </div>
                      <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-db7656e vamtam-has-underline-anim elementor-widget elementor-widget-button" data-id="db7656e" data-element_type="widget" data-e-type="widget" data-widget_type="button.default">
                        <div class="elementor-widget-container">
                          <div class="elementor-button-wrapper">
                            <a class="elementor-button elementor-button-link elementor-size-sm" href="/leadership/">
                              <span class="elementor-button-content-wrapper">
                                <span class="elementor-button-text">
                                  <span class="vamtam-btn-text">Learn more</span>
                                </span>
                              </span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="elementor-column elementor-col-66 elementor-top-column elementor-element elementor-element-01ec793" data-id="01ec793" data-element_type="column" data-e-type="column">
                    <div class="elementor-widget-wrap elementor-element-populated">
                      <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-1defef8 elementor-grid-1 elementor-posts--thumbnail-left vamtam-has-hr-layout elementor-grid-tablet-1 elementor-posts--thumbnail-mobile-top vamtam-nav-pos-mobile-custom vamtam-has-nav-on-mobile vamtam-nav-pos-custom elementor-grid-mobile-1 vamtam-has-nav vamtam-has-title-underline-anim elementor-widget elementor-widget-global elementor-global-10925 elementor-widget-posts" data-id="1defef8" data-element_type="widget" data-e-type="widget" data-settings="{&quot;vamtam_classic_columns&quot;:&quot;1&quot;,&quot;vamtam_classic_columns_tablet&quot;:&quot;1&quot;,&quot;vamtam_classic_row_gap&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:0,&quot;sizes&quot;:[]},&quot;vamtam_classic_columns_mobile&quot;:&quot;1&quot;,&quot;vamtam_classic_row_gap_tablet&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;vamtam_classic_row_gap_mobile&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]}}" data-widget_type="posts.vamtam_classic">
                        <div class="elementor-widget-container">
                          <div class="elementor-posts-container elementor-posts elementor-posts--skin-vamtam_classic elementor-grid" role="list">
                            <article v-for="leads in aboutContentStore.contents.leaderships" :key="leads._id" class="elementor-post elementor-grid-item post-10837 page type-page status-publish has-post-thumbnail hentry" role="listitem">
                              <a class="elementor-post__thumbnail__link" href="#" tabindex="-1">
                                <div class="elementor-post__thumbnail">
                                  <img decoding="async" width="798" height="1038" :src="leads.image" class="attachment-full size-full wp-image-2137 entered lazyloaded" alt="" :data-lazy-srcset="`${leads.image} 798w, ${leads.image} 231w, ${leads.image} 787w, leads.image 768w`" data-lazy-sizes="(max-width: 798px) 100vw, 798px" :data-lazy-src="leads.image" data-ll-status="loaded" sizes="(max-width: 798px) 100vw, 798px" :srcset="`${leads.image} 798w, ${leads.image} 231w, ${leads.image} 787w, ${leads.image} 768w`">
                                  <noscript><img loading="lazy" decoding="async" width="798" height="1038" :src="leads.image" class="attachment-full size-full wp-image-2137" alt="" :srcset="`${leads.image} 798w, ${leads.image} 231w, ${leads.image} 787w, ${leads.image} 768w`" sizes="(max-width: 798px) 100vw, 798px" /></noscript>
                                </div>
                              </a>
                              <div class="elementor-post__text">
                                <h3 class="elementor-post__title">
                                  <a href="#">{{ leads.title }}</a>
                                </h3>
                                <div class="elementor-post__excerpt">
                                  <p v-html="leads.descriptions"></p>
                                </div>
                              </div>
                            </article>
                          </div>
                          <div class="vamtam-nav">
                            <span class="vamtam-nav-btn vamtam-nav-btn-prev disabled">
                              <i class="vamtamtheme- vamtam-theme-arrow-left"></i>
                            </span>
                            <span class="vamtam-nav-btn vamtam-nav-btn-next">
                              <i class="vamtamtheme- vamtam-theme-arrow-right"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
						</div>
					</div>
				</article>
			</div>
		</div>
	</div>
</template>
<script>
  
  import "@/assets/css/about.css";
	
  import { onMounted } from 'vue'
  import { useAboutContentStore } from '@/stores/aboutContentStore'

  export default {
    name: 'AboutUsView',
    setup() {
      const aboutContentStore = useAboutContentStore()

      onMounted(async () => {
        await aboutContentStore.fetchAboutPage()
      })

      return {
        aboutContentStore
      }
    },
  }
</script>
<style scoped>
	.elementor-812 .elementor-element.elementor-element-ac4e796:not(.elementor-motion-effects-element-type-background), .elementor-812 .elementor-element.elementor-element-ac4e796 > .elementor-motion-effects-container > .elementor-motion-effects-layer {
		background-image: none;
		background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
	}
	.elementor-812 .elementor-element.elementor-element-4dc92d4:not(.elementor-motion-effects-element-type-background) > .elementor-widget-wrap, .elementor-812 .elementor-element.elementor-element-4dc92d4 > .elementor-widget-wrap > .elementor-motion-effects-container > .elementor-motion-effects-layer {
		background-image: none;
		background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
	}
  .elementor-kit-5 h1 {
    font-size: 40px;
  }
  .elementor-kit-5 h2 {
    font-size: 30px;
  }
  .elementor-812 .elementor-element.elementor-global-10925 .elementor-post__title, .elementor-812 .elementor-element.elementor-global-10925 .elementor-post__title a {
    font-size: 24px;
  }
</style>